module.exports = __webpack_public_path__ + "img/2.028c314b.jpg";